<div class="dialog-field-group">
    @if( showLabel ) {
        <mat-label class="mat-form-field-label">
            {{ label }}
            @if( required ) {
                <span class="req">*</span>
            }
        </mat-label>
    }
    <mat-form-field appearance="outline" #fileField>
        <input matInput
               [formControl]="fileFormControl"
               (click)="openFilePicker()"
               [readonly]="true"
               [placeholder]="getPlaceholder()">

        <mat-icon matSuffix class="action-icon" matTooltip="Clear selection" (click)="onClearSelection()">cancel</mat-icon>

        @if (initError) {
            <mat-error>{{ initError }}</mat-error>
        }
        @if (fileFormControl.hasError('required') && (fileFormControl.touched || fileFormControl.dirty)) {
            <mat-error>File is required</mat-error>
        }
        @if (fileFormControl.hasError('pattern') && (fileFormControl.touched || fileFormControl.dirty)) {
            <mat-error>Filename has invalid characters</mat-error>
        }
    </mat-form-field>
</div>
